import { cx } from "@emotion/css";
import { useTranslation } from "react-i18next";
import { CircleChartWithStats } from "src/components/Statistics/CircleChart";

interface DepartmentStats {
	departmentName: string;
	correctAnswersPercent: number;
	wrongAnswersPercent: number;
	cancelledQuestionsPercent: number;
	skippedQuestionsPercent: number;
	totalQuestions: number;
	correctAnswers: number;
	wrongAnswers: number;
	skippedQuestions: number;
	cancelledQuestions: number;
	score: number;
}

interface ExamDepartmentsStatisticsProps {
	stats: DepartmentStats[];
}

export const ExamDepartmentsStatistics = ({
	stats,
}: ExamDepartmentsStatisticsProps) => {
	const { t } = useTranslation();
	const departmentsExist = stats.length > 0;

	const renderDepartmentsStats = () => {
		return stats.map(({ departmentName, ...stats }) => (
			<CircleChartWithStats
				key={departmentName}
				className="w-25"
				stats={stats}
				title={departmentName}
			/>
		));
	};

	return (
		<div className="flex flex-col gap-12">
			<div
				className={cx(
					"flex items-center flex-wrap gap-20 exam-department-statistics",
				)}
			>
				{departmentsExist && renderDepartmentsStats()}
				{!departmentsExist && (
					<div className="flex items-center justify-center w-100 flex-col">
						<span className="size-18-light">
							{t("modals.statistics.empty.title")}
						</span>
						<span className="mt-8 size-16-light text-grey text-center">
							{t("modals.statistics.empty.description")}
						</span>
					</div>
				)}
			</div>
		</div>
	);
};
